<template>
    <div class="page">
        <Breadcrumb title="交易中心" :breadcrumb="breadcrumb" />
        <detail-content title="交易及退款信息">
            <div>
                <div class="list">
                    <div class="list_label"><span>商户订单号</span> <span>{{billInfo.outTradeNo}}</span></div>
                    <div class="list_label"><span>交易订单号</span> <span>{{billInfo.dealTradeNo}}</span></div>
                </div>
                <div class="list">
                    <div class="list_label"><span>渠道支付流水号</span> <span>{{billInfo.tradeNo}}</span></div>
                    <div class="list_label"><span>订单金额(元)</span> <span>{{billInfo.orderAmount}}</span></div>
                </div>
                <div class="list">
                    <div class="list_label"><span>已申请退款金额(元)</span> <span>{{billInfo.refundAmount||0}}</span><span class="lookRefund" @click="lookRefund">查看已申请退款单</span></div>
                </div>
            </div>
        </detail-content>
        <detail-content title="退款方式">
            <div class="list">
                <div class="list_label"><span>退款方式</span> <span>原路返回</span></div>
            </div>
        </detail-content>
        <detail-content title="退款信息">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="refundInfo">
                <el-form-item label="退款金额(元)" prop="refundAmount">
                    <el-input type="number" v-model="ruleForm.refundAmount" placeholder="请输入退款金额"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                    <el-button @click="back">返回</el-button>
                </el-form-item>
            </el-form>
        </detail-content>
    </div>
</template>
<script>
import { breadcrumb } from '@/mixins/index.js';
import DetailContent from '@trading/components/detail-content.vue';
import { mapActions, mapState } from 'vuex';
export default {
  name: 'applyRefund',
  mixins: [breadcrumb],
  components: {
    DetailContent,
  },
  data() {
    return {
      ruleForm: {
        refundAmount: '',
        outTradeNo: '',
        dealTradeNo: '',
        refundNotifyUrl: '',
      },
      rules: {
        refundAmount: [{ required: true, message: '请输入退款金额', trigger: 'blur' }],
      },
    };
  },
  computed: {
    ...mapState({
      billInfo: (state) => state.trading.billInfo,
    }),
  },
  created() {
    this.getBillById({ id: this.$route.query.id });
  },
  methods: {
    ...mapActions('trading', ['getBillById']),
    ...mapActions('refund', ['businessRefund']),
    //查看退款
    lookRefund() {
      this.$router.push({ path: 'refund/detail', query: { id: this.$route.query.id } });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.outTradeNo = this.billInfo.outTradeNo;
          this.ruleForm.dealTradeNo = this.billInfo.dealTradeNo;
          this.businessRefund(this.ruleForm);
          this.$router.push({ path: 'refund/detail', query: { id: this.$route.query.id } });
        } else {
          return false;
        }
      });
    },
    back() {
      this.$router.back(-1);
    },
  },
};
</script>
<style lang="less" scoped>
.list {
  display: flex;
  line-height: 50px;
  background: #fff;
  .list_label {
    width: 500px;
    display: flex;
  }
  span:nth-child(1) {
    display: inline-block;
    width: 140px;
    margin-left: 30px;
  }
  .lookRefund {
    color: #4359b7;
    margin-left: 30px;
  }
  /deep/.el-input,
  /deep/.el-textarea {
    width: 380px;
  }
}
.refundInfo {
  /deep/.el-form-item {
    margin-top: 20px;
  }
  /deep/.el-input__inner {
    width: 300px;
  }
}
</style>